import Aos from "../components/aos";
import PinnedSections from "../components/PinnedSections";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

/**
 * Default Page
 */
const PageDefault = ($) => {
	if ($("body").hasClass("page-template-default")) {
		Aos();
		gsap.registerPlugin(ScrollTrigger);
		PinnedSections(gsap ,ScrollTrigger, $)
	}
};

export default PageDefault;
